import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router";
import { Toast } from "../../CustomComponent/toast";

const AlphaDailyCallRecords = ({ alphaCallRecordsTrackFrom }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    performRequest(
      "GET",
      `/alpha-call-tracker/get-alpha-call-records-count?days=${alphaCallRecordsTrackFrom}`,
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, [alphaCallRecordsTrackFrom]);

  return (
    <div
      className={
        alphaCallRecordsTrackFrom != null
          ? "page-wrapper"
          : "page-wrapper  text-white min-vh-100"
      }
    >
      <div className={alphaCallRecordsTrackFrom != null ? "" : "m-4"}>
        {alphaCallRecordsTrackFrom == null && (
          <div className="text-center mb-4">
            <h1 className="display-4 text-dark fw-bold">
              Sales Team Performance Daily Report
            </h1>
            <div
              onClick={() => navigate("/i-dashboard")}
              className="text-secondary fs-1 d-flex align-items-center justify-content-center gap-2 cursor-pointer"
            >
              <span className="status-indicator status-green status-indicator-animated">
                <span className="status-indicator-circle"></span>
                <span className="status-indicator-circle"></span>
                <span className="status-indicator-circle"></span>
              </span>

              <p className="mb-0">Live dashboard</p>
            </div>
          </div>
        )}

        <div className={alphaCallRecordsTrackFrom != null ? "" : "card"}>
          <div
            className={
              alphaCallRecordsTrackFrom != null
                ? "table-responsive"
                : "table-responsive fs-1"
            }
          >
            <table className="table table-vcenter table-striped table-hover text-center">
              <thead
                className={
                  alphaCallRecordsTrackFrom != null ? "" : "table-dark"
                }
              >
                <tr>
                  <th
                    className={
                      alphaCallRecordsTrackFrom != null
                        ? "text-start"
                        : "text-start fs-3"
                    }
                  >
                    Employee
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Calls
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Unique
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Ans
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    FL Calls
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Ph Call
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    WA
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Quotes
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Leads
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Duration
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    SI
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    FL taken
                  </th>
                  <th
                    className={alphaCallRecordsTrackFrom != null ? "" : "fs-3"}
                  >
                    Fl Pending
                  </th>
                  {/* <th>In</th>
                  <th>Out</th>
                  <th>Miss</th>
                  <th>Attempt</th>
                  <th>Follow Ups</th>
                  <th>Done</th>
                  <th>Pending</th> */}
                </tr>
              </thead>
              <tbody>
                {data?.map((item) => (
                  <tr key={item?.user?.id}>
                    <td className="text-start">
                      <div className="fw-bold">{item?.user?.userName}</div>
                    </td>

                    <td>{item?.stats?.totalCalls}</td>
                    <td>{item?.stats?.uniqueCalls}</td>
                    <td>
                      <span className="badge bg-green-lt">
                        {item?.stats?.answeredCalls}
                      </span>
                    </td>
                    <td>{item.followUpCalls}</td>
                    <td>
                      {item?.stats?.totalCalls - (item?.whatsappCalls || 0)}
                    </td>
                    <td>{item.whatsappCalls}</td>
                    <td>{item.quotations}</td>
                    <td>
                      <span className="badge bg-green-lt">
                        {item.leadsCreated}
                      </span>
                    </td>
                    <td>{item?.stats?.totalDuration}</td>
                    <td>{item.siteInspections}</td>
                    <td>{item.completedFollowupsCount}</td>
                    <td>
                      <span className="badge bg-red-lt">
                        {item.pendingFollowupsCount}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

function Metric({ title, value, color }) {
  return (
    <div className="col-6">
      <div className={`card card-sm bg-${color}-lt`}>
        <div className="card-body text-center">
          <div className="h1 mb-1 fw-bold">{value}</div>

          <div className="text-secondary fw-semibold">{title}</div>
        </div>
      </div>
    </div>
  );
}

export default AlphaDailyCallRecords;
